<div class="inventory-items-container">
	<div class="content">
		<app-loading-state [isLoading]="isLoading" [loadedContent]="loadedContent"></app-loading-state>
		<ng-template #loadedContent>
			<ng-container *ngIf="userHasAccess; else noAccess">
				<div class="inventory-container">
					<div class="content">
						<ng-container *ngIf="isMobileSize; else desktopSize">
							<app-mobile-inventory-table
								[isLoading]="inventoryLoading"
								[inventoryItems]="inventoryItems"
								[searchTerm$]="searchTerm$"
								[showArchived$]="showArchived$"
								(inventoryItemEdit)="onInventoryItemEdit($event)"
								(inventoryItemManage)="onInventoryItemManage($event)"
								(inventoryItemArchive)="onInventoryItemArchive($event)"
								(inventoryItemUnarchive)="onInventoryItemUnarchive($event)"
								(addNewEvent)="openAddInventoryItemOffcanvas()"
							></app-mobile-inventory-table>
						</ng-container>
						<ng-template #desktopSize>
							<app-desktop-inventory-table
								[isLoading]="inventoryLoading"
								[inventoryItems]="inventoryItems"
								[searchTerm$]="searchTerm$"
								[showArchived$]="showArchived$"
								(inventoryItemEdit)="onInventoryItemEdit($event)"
								(inventoryItemManage)="onInventoryItemManage($event)"
								(inventoryItemArchive)="onInventoryItemArchive($event)"
								(inventoryItemUnarchive)="onInventoryItemUnarchive($event)"
								(addNewEvent)="openAddInventoryItemOffcanvas()"
							></app-desktop-inventory-table>
						</ng-template>
					</div>
				</div>
			</ng-container>

			<ng-template #noAccess>
				<app-unauthorised-banner
					headingText="It looks like you do not have access to this organisation or do not have the required access level."
				></app-unauthorised-banner>
			</ng-template>
		</ng-template>
	</div>
</div>
